import {FAVORITE_PREFIX, ItemFavoriteStore} from '../store';

export type TValidationResult = true | string;
export type TValidationRule = (value: string) => TValidationResult;

const RE_FAVORITE_NAME_INVALID_CHARS = /[^A-Za-z0-9 ']/g;
const RE_SINGLE_QUOTE = /[\u2018\u2019\u201B]/g;


class FormValidation {
	convertSmartSingleQuotesToStraight(value: string): string {
		return value.replace(RE_SINGLE_QUOTE, '\'');
	}

	digitsOnly(value: string): string {
		return value.replace(/\D/g, '');
	}

	ruleFavoriteNameIsUnique(value: string): TValidationResult {
		const valTrim = value.trim();
		return !ItemFavoriteStore.favoriteNameExists(valTrim) || `You already have a favorite named ${FAVORITE_PREFIX}${valTrim}`;
	}

	ruleFavoriteNameIsValid(value: string): TValidationResult {
		const valTrimmed = value.trim();

		if(RE_FAVORITE_NAME_INVALID_CHARS.test(valTrimmed)) {
			const invalidChars = valTrimmed.match(RE_FAVORITE_NAME_INVALID_CHARS);
			const uniqueChars = Array.from(new Set(invalidChars)).join(' ');
			return `Favorite name includes invalid character${uniqueChars.length > 1 ? 's' : ''}: ${uniqueChars}`;
		} else {
			return true;
		}
	}

	rulePhoneNumberLength(value: string): TValidationResult {
		// const phoneNumber = this.digitsOnly(value); // FIXME: `this` is breaking EnterPhoneVerifyPin
		const phoneNumber = value.replace(/\D/g, '');
		return (phoneNumber.startsWith('1') ? phoneNumber.length === 11 : phoneNumber.length === 10) ||
			'Please enter a valid phone number';
	}

	ruleRequired(value: string): TValidationResult {
		return !!value.trim() || 'Field is required';
	}
}

export const FormValidationService = new FormValidation();
